export default function useFbq() {
    function fbqTracking(event, content){
        window.fbq(event, content);
    }

    return fbqTracking;
}